import Parse from "parse";
import { getClassName } from "./ParseConfiguration";
import { Notification, NotificationModel } from "../Models/Notification.ts";
import { setLimit } from "./ParseConfiguration";
import { handleError } from "./ErrorHandler.ts";


const NOTIFICATION_TABLE: any = getClassName("Notification")

export interface CustomNotificationPayload {
  message: string
  title?: string
  buttonLabel?: string
  buttonLink?: string
}


export async function getNotifications(): Promise<NotificationModel[]> {
  try {
    const query = new Parse.Query(NOTIFICATION_TABLE)
    query.include("user")
    query.descending("createdAt")
    const count = await query.count()
    setLimit(query, count)
    const result = await query.find()
    return result.map((parseObject: any) =>
      Notification.convertFromParseObject(parseObject)
    )

  } catch (error) {
    handleError(error)
    throw error
  }
}

export async function getNotificationByID(id: string): Promise<any> {
  try {
    const query = new Parse.Query(NOTIFICATION_TABLE)
    query.include("user")
    const result = await query.get(id)
    return result

  } catch (error: any) {
    if (error?.code !== 101 && error?.message !== "Object not found.") {
      handleError(error)
    }
    throw error
  }
}

export async function updateNotificationStatus(id: string): Promise<void> {
  try {
    const result = await getNotificationByID(id)
    if (!result) {
      return
    }
    await result.destroy({})

  } catch (error: any) {
    if (error?.code === 101 || error?.message === "Object not found.") {
      return
    }
    handleError(error)
    throw error
  }
}

export async function sendCustomNotificationForAllUsers(payload: CustomNotificationPayload): Promise<any> {
  const params: Record<string, string> = {
    message: payload.message,
    alert: payload.message
  }

  if (payload.title) {
    params.title = payload.title
  }

  if (payload.buttonLabel) {
    params.buttonLabel = payload.buttonLabel
  }

  if (payload.buttonLink) {
    params.buttonLink = payload.buttonLink
  }

  return await Parse.Cloud.run("sendCustomNotificationForAllUsers", params)
}

export async function sendCustomMessageForUsers(
  payload: CustomNotificationPayload,
  userIds: string[]
): Promise<any> {
  const params: Record<string, string | string[]> = {
    message: payload.message,
    userIds: userIds
  }

  if (payload.title) {
    params.title = payload.title
  }

  if (payload.buttonLabel) {
    params.buttonLabel = payload.buttonLabel
  }

  if (payload.buttonLink) {
    params.buttonLink = payload.buttonLink
  }

  return await Parse.Cloud.run("sendCustomMessageForUsers", params)
}
